<mat-card appearance="outlined" class="flex basis-full h-full">
  <mat-card-content>
    <h2 class="text-slate-500">My Jobs</h2>
    @if (jobsSummary$ | async; as summary) {
    <h1>{{ totalJobCount$ | async }}</h1>
    <div class="group gap-y-4 flex flex-col justify-start items-stretch">
      @if (summary.deliveries) {
      <div class="flex flex-row justify-start items-center gap-x-6">
        <p>Transport: {{ summary.deliveries }}</p>
        <button class="lg:invisible group-hover:visible" mat-button [routerLink]="['my-delivery-jobs']">
          View
        </button>
      </div>
      }
      @if (summary.workshop) {
      <div class="flex flex-row justify-start items-center gap-x-6">
        <p>Workshop: {{ summary.workshop }}</p>
        <button class="lg:invisible group-hover:visible" mat-button [routerLink]="['my-workshop-jobs']">
          View
        </button>
      </div>
      }
      @if (showNoJobsMessage) {
      <p class="w-full text-center">
        <em>You have no jobs assigned to you. When you get assigned a
          transport or workshop job they will appear here.</em>
      </p>
      }
    </div>
    }
  </mat-card-content>
</mat-card>